<template>
  <div ref="tvaScrollIndicator" id="tvaScrollIndicator"></div>
</template>
<script>
export default {
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      const winHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const perc = (100 * scrollPos) / (docHeight - winHeight);
      this.$refs.tvaScrollIndicator.style.width = perc + "%";
    });
  }
};
</script>
<style lang="scss" scoped>
#tvaScrollIndicator {
  position: fixed;
  top: 50px;
  left: 0;
  height: 2px;
  background-color: $primary;
  z-index: 999;
}
</style>
